// ============================================
// MAPPERS: Calibration
// ============================================
// Archivo: src/utils/calibrationMappers.js

/**
 * Mapear calibración desde PostgreSQL (snake_case) a Frontend (camelCase)
 */
export const mapCalibrationFromBackend = (c) => {
  if (!c) return null;
  
  // ✅ Helper para extraer solo YYYY-MM-DD
  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    return isoDate.split('T')[0];
  };
  
  return {
    id: c.id,
    equipmentId: c.equipment_id,
    date: formatDate(c.fecha_calibracion),           // ✅ Corregido
    nextDate: formatDate(c.proxima_calibracion),     // ✅ Corregido
    result: c.resultado || 'aprobado',
    observations: c.observaciones || '',
    certificate: c.numero_certificado || '',
    technician: c.tecnico || '',
    filePath: c.archivo_path || null,
    
    // Datos adicionales del JOIN
    equipmentName: c.equipment_name,
    equipmentCode: c.equipment_code,
    createdAt: c.created_at
  };
};

/**
 * Mapear calibración desde Frontend (camelCase) a Backend (para envío)
 */
export const mapCalibrationToBackend = (c) => {
  return {
    equipmentId: c.equipmentId,
    date: c.date,
    nextDate: c.nextDate,
    result: c.result,
    observations: c.observations || '',
    certificateNumber: c.certificate || '',
    technician: c.technician || ''
  };
};